import { render, staticRenderFns } from "./TemperatureChecksTable.vue?vue&type=template&id=3101f4f8"
import script from "./TemperatureChecksTable.vue?vue&type=script&lang=js"
export * from "./TemperatureChecksTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports